// Flag emoji from a country/region code via Unicode regional indicators —
// no image assets needed. Internal 'UK' must map to ISO 'GB' for the emoji.
const ISO_OVERRIDES: Record<string, string> = { UK: 'GB' };

export function countryFlagEmoji(regionCode: string): string {
  const iso = (ISO_OVERRIDES[regionCode] || regionCode || '').toUpperCase();
  if (!/^[A-Z]{2}$/.test(iso)) return '🌍';
  return String.fromCodePoint(...[...iso].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
}
